/**
 * Pure formatting helpers for the Shadow AI Discovery UI. Kept in a non-TSX
 * module so the component file can be fast-refresh friendly.
 */

/**
 * Cap a string to `max` characters with an ellipsis. Returns "—" for empty
 * input so the UI never renders a blank cell for missing data.
 *
 * Guards against absurdly long, attacker-controlled strings (asset names,
 * ARNs, metadata) reaching the DOM. Callers render the result as text.
 */
export function truncate(value: string | null | undefined, max: number): string {
  if (value === null || value === undefined || value === "") return "—";
  if (value.length <= max) return value;
  return `${value.slice(0, max)}…`;
}
